var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "mb10 title" }, [_vm._v("留言")]),
      _vm._v(" "),
      _vm._l(_vm.reply, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "acea-row row-between mb25" },
          [
            _c(
              "div",
              { staticClass: "flex-between", staticStyle: { width: "100%" } },
              [
                _c("div", { staticClass: "mb15 flex" }, [
                  _c("div", { staticClass: "pic mr10" }, [
                    _c("img", { attrs: { src: item.card.avatar } }),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "fonts" }, [
                      _vm._v(_vm._s(item.card.name)),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time" }, [
                      _vm._v(_vm._s(item.created_at)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fonts mt5" }, [
                      _vm._v(_vm._s(item.content)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _vm.$store.state.user.userInfo.uid === item.card.uid
                  ? _c(
                      "div",
                      {
                        staticClass: "del mt10",
                        on: {
                          click: function ($event) {
                            return _vm.del(item.id)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "el-icon-delete mr5" }),
                        _vm._v("删除\n      "),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }